import  React from 'react'
import MainChipsContainer from "../../components/HeaderButton/indexMain";
import {Heading, Img} from "../../components";
import LanguageSwitcher from "../../components/languageSwitcher";
import {Link} from "react-router-dom";

export default function MainHeader () {
    return (
        <div className="px-6 pt-10 container-xs">
            <div className="justify-between">
                <div className="flex items-center justify-between">
                    <Link to={'/main'}>
                    <Img
                        src="/images/logo_header.svg"/>
                    </Link>
                    <div className=" pl-6">
                        <MainChipsContainer/>
                    </div>
                    <div className="flex items-center gap-4">
                    <LanguageSwitcher/>
                    <button
                        className="w-[152px] h-[32px] rounded-[30px] bg-[#0C88F0] flex items-center justify-center px-2 sm:hidden"
                    >
                        <img
                            src={"/images/callUsIcon.svg"}
                            alt="call usIcon"
                        />
                        <Heading
                            size={"desktop_body_s"}
                            className={"text-[#FFFFFF] w-auto flex-row"}>
                            <a href="tel:+74955427541">
                                +7(495)542-75-41
                            </a>
                        </Heading>
                    </button>
                    </div>
                </div>
            </div>
        </div>
    )
}